import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import {
    Avatar, FormControlLabel,
    List,
    ListItem, ListItemAvatar,
    ListItemSecondaryAction,
    ListItemText, Radio, RadioGroup, Table, TableBody, TableCell, TableHead, TableRow, Typography,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DialogActions from "@mui/material/DialogActions";
import useStore from "../../store";

export default function AddWidgetDialog() {
    const availableWidgets = useStore((state) => state.dashboard.availableWidgets);
    const addWidget = useStore((state) => state.dashboard.widgets.add);
    const setAddWidgetDialogOpen = useStore((store) => store.dashboard.widgets.setAddWidgetDialogOpen);
    const addWidgetDialogOpen = useStore((store) => store.dashboard.widgets.addWidgetDialogOpen);
    // const setAddWidgetDialogOpen = useStore((state) => state.dashboard.widgets.setAddWidgetDialogOpen);

    // const [open, setOpen] = useState(true);
    const [section, setSection] = useState("main");

    const onAddWidget = (widget) => {
        addWidget(section, widget);
        setAddWidgetDialogOpen(false);
    };

    const closeAddWidget = () => {
        setAddWidgetDialogOpen(false);
    };

    const onChange = (e) => setSection(e.target.value);

    return (
        <Dialog
            fullWidth
            open={addWidgetDialogOpen}
            // onClose={() => setOpen(false)}
            onExited={closeAddWidget}
            scroll="paper"
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
            sx={{
                zIndex: "1190!important",
            }}
        >
            <DialogTitle id="scroll-dialog-title">Widget hinzufügen</DialogTitle>
            <DialogContent
                id="scroll-dialog-description"
                dividers
                sx={{
                    padding: 0,
                }}
            >
                <RadioGroup row aria-label="select-section" name="select-section" value={section} onChange={onChange}>
                    <Table
                        mr={5}
                        ml={5}
                        sx={{
                            width: "100%",
                            height: 50,
                        }}
                    >
                        <TableHead>
                            <TableRow>
                                <TableCell colSpan={3}>
                                    <Typography>Bereich auswählen</Typography>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell sx={{
                                    width: "70%",
                                    verticalAlign: "middle",
                                    textAlign: "center",
                                }}
                                >
                                    <FormControlLabel
                                        value="main"
                                        control={<Radio />}
                                        label={(
                                            <>
                                                <FontAwesomeIcon icon="tachometer-alt" />
                                                {" "}
                                                Dashboard
                                            </>
                                        )}
                                        labelPlacement="top"
                                    />
                                </TableCell>
                                <TableCell sx={{
                                    width: "30%",
                                    verticalAlign: "middle",
                                    textAlign: "center",
                                    borderLeft: "4px #f4f7f9 solid",
                                }}
                                >
                                    <FormControlLabel
                                        value="right"
                                        control={<Radio />}
                                        label={(
                                            <>
                                                <FontAwesomeIcon icon="columns" />
                                                {" "}
                                                Sidebar
                                            </>
                                        )}
                                        labelPlacement="top"
                                    />
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </RadioGroup>
                <List>
                    {availableWidgets.map((availableWidget) => (
                        <ListItem key={availableWidget.title}>
                            <ListItemAvatar>
                                <Avatar>
                                    <FontAwesomeIcon
                                        style={{
                                            fontSize: 18,
                                        }}
                                        icon={availableWidget.icon}
                                    />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText
                                primary={availableWidget.title}
                                secondary={availableWidget.info}
                            >
                                {availableWidget.icon}
                            </ListItemText>
                            <ListItemSecondaryAction>
                                <Button variant="outlined" onClick={() => onAddWidget(availableWidget)}>
                                    <FontAwesomeIcon icon="check" />
                                </Button>
                            </ListItemSecondaryAction>
                        </ListItem>
                    ))}
                </List>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    onClick={() => setAddWidgetDialogOpen(false)}
                    color="secondary"
                    startIcon={<FontAwesomeIcon icon="times" />}
                >
                    Abbrechen
                </Button>
            </DialogActions>
        </Dialog>
    );
}
